import { render } from "./CatMaterialAlmacenView.vue?vue&type=template&id=3be7de58&scoped=true"
import script from "./CatMaterialAlmacenView.vue?vue&type=script&lang=js"
export * from "./CatMaterialAlmacenView.vue?vue&type=script&lang=js"

import "./CatMaterialAlmacenView.vue?vue&type=style&index=0&id=3be7de58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be7de58"]])

export default __exports__